import api from "../config/api";
import { EmpReport } from "../types/EmpReport";

const API_URL = "/employeeReport";

// Get all empReports
export const getEmpReports = () =>
  api.get(`${API_URL}/`).then((res) => res.data.data);

// Get empReport by ID using query parameter
export const getEmpReportById = (id: number) => api.get(`${API_URL}/?id=${id}`);

// Create a new empReport
export const createEmpReport = (data: EmpReport) =>
  api.post(`${API_URL}/`, data);

// Update an empReport
export const updateEmpReport = (id: number, data: EmpReport) =>
  api.put(`${API_URL}/?id=${id}`, data);

// Delete an empReport
export const deleteEmpReport = (id: number) =>
  api.delete(`${API_URL}/?id=${id}`);
